/******************************************
 *  Author : Suraj Sharma
 *  Created On : Tue Dec 22 2020
 *  File : Types.js
 *******************************************/

export const VERIFY_PANACEA_USER = 'VERIFY_PANACEA_USER';
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';